import {matchPath} from "react-router-dom";

function getParams(currentPath, routeToMatch){
    const matchedInfo = matchPath(currentPath, {
        path: routeToMatch.path,
        exact: true,
        strict: false
    });

    if(matchedInfo === null)
        return null;

    let routeParams = Object.keys(routeToMatch.params);
    let paramObj = {};
    for(let param in routeParams)
        paramObj[routeParams[param]] = matchedInfo.params[routeParams[param]];

    return paramObj;
}

export {getParams};